module.exports = {
  prismicRepo: '14islands',
}
